import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { ThemeProvider, themeConfig } from "./theme";
import ProtectedRoute from './components/ProtectedRoute';
import { checkAuth } from './store/slices/authSlice';

// Pages
import DashboardPage from "./pages/DashboardPage";
import UserDetailPage from "./pages/UserDetailPage";
import UserStartupsPage from "./pages/UserStartupsPage";
import StartupDetailPage from "./pages/StartupDetailPage";
import UserInvestmentsPage from "./pages/UserInvestmentsPage";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import Campaigns from "./pages/Campaigns";
import ProfilePage from "./pages/ProfilePage";
import CampaignsRegister from "./pages/CampaignsRegister";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import KebabPage from "./pages/KebabPage";
import ErdalPage from "./pages/ErdalPage";
import MyCampaigns from "./pages/MyCampaigns";
import Invest from "./components/forms/InvestmentForm";
import CampaignDetail from "./pages/CampaignDetail";
import AngelInvestor from "./pages/AngelInvestor";
import InvestorInformation from "./pages/InvestorInformation";
import BecomeEntrepreneur from "./pages/BecomeEntrepreneur";
import { SettingsProvider } from './components/settings';
import { defaultSettings } from "./components/settings";
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { ProfileProvider } from './context/ProfileContext';
import AdminInvestmentsPage from "./pages/AdminInvestmentsPage";
import AllStartupsPage from "./pages/AllStartupsPage";
import InvestmentDetailPage from "./pages/InvestmentDetailPage";
import StartupInvestmentsPage from "./pages/StartupInvestmentsPage";
import MailTemplates from "./pages/MailTemplates";
import CommitteeMembersPage from "./pages/CommitteeMembersPage";
import CommitteeValidationPage from './pages/CommitteeValidationPage';
import MailManagementPage from "./pages/MailManagementPage";
import HeroManagementPage from './pages/HeroManagementPage';

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <html>
       <InitColorSchemeScript
          defaultMode={themeConfig.defaultMode}
          modeStorageKey={themeConfig.modeStorageKey}
          attribute={themeConfig.cssVariables.colorSchemeSelector}
        />
      <SettingsProvider defaultSettings={defaultSettings}>
      <ThemeProvider>
        <ProfileProvider>
          <Routes>
            {/* Public Route - Login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected Admin Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />
            
            <Route path="/kullanici/:userId" element={
              <ProtectedRoute>
                <UserDetailPage />
              </ProtectedRoute>
            } />
            
            <Route path="/startuplar/:userId" element={
              <ProtectedRoute>
                <UserStartupsPage />
              </ProtectedRoute>
            } />

            <Route path="/yatirimlar" element={
              <ProtectedRoute>
                <AdminInvestmentsPage />
              </ProtectedRoute>
            } />

            <Route path="/mail-sablonlari" element={
              <ProtectedRoute>
                <MailTemplates />
              </ProtectedRoute>
            } />
            
            <Route path="/mail-yonetim" element={
              <ProtectedRoute>
                <MailManagementPage />
              </ProtectedRoute>
            } />

            <Route path="/komite-uyeleri" element={
              <ProtectedRoute>
                <CommitteeMembersPage />
              </ProtectedRoute>
            } />
            
            <Route path="/yatirimlar/detay/:id" element={
              <ProtectedRoute>
                <InvestmentDetailPage />
              </ProtectedRoute>
            } />
            
            <Route path="/startuplar/detay/:startupId" element={
              <ProtectedRoute>
                <StartupDetailPage />
              </ProtectedRoute>
            } />

            <Route path="/startup/yatirimlar/:startupId" element={
              <ProtectedRoute>
                <StartupInvestmentsPage />
              </ProtectedRoute>
            } />
            
            <Route path="/yatirimlar/:userId" element={
              <ProtectedRoute>
                <UserInvestmentsPage />
              </ProtectedRoute>
            } />

            {/* Public Routes */}
            <Route
              path="/giris"
              element={<Login />}
            />
            <Route
              path="/kayit-ol"
              element={<Register />}
            />

            {/* Private Routes */}
            <Route
              path="/profil"
              element={<ProtectedRoute><ProfilePage /></ProtectedRoute>}
            />
            <Route
              path="/kampanyalar/kampanya-baslat"
              element={<ProtectedRoute><CampaignsRegister /></ProtectedRoute>}
            />
            <Route
              path="/kampanyalarım"
              element={<ProtectedRoute><MyCampaigns /></ProtectedRoute>}
            />
            <Route
              path="/kampanyalar/kayit/:startupId"
              element={<ProtectedRoute><CampaignsRegister /></ProtectedRoute>}
            />

            <Route
              path="/invest"
              element={<ProtectedRoute><Invest /></ProtectedRoute>}
            />

            {/* General Routes */}
            <Route path="/kampanyalar" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
            <Route path="/melek-yatirimcilar" element={<ProtectedRoute><AngelInvestor /></ProtectedRoute>} />
            <Route path="/nasil-yatirimci-olunur" element={<ProtectedRoute><InvestorInformation /></ProtectedRoute>} />
            <Route path="/nasil-girisimci-olunur" element={<ProtectedRoute><BecomeEntrepreneur /></ProtectedRoute>} />

            <Route path="/kampanyalar/detay/:startupId" element={<ProtectedRoute><CampaignDetail /></ProtectedRoute>} />
            <Route path="/kebap" element={<ProtectedRoute><KebabPage /></ProtectedRoute>} />
            <Route path="/erdal" element={<ProtectedRoute><ErdalPage /></ProtectedRoute>} />

            <Route path="/startuplar" element={
              <ProtectedRoute>
                <AllStartupsPage />
              </ProtectedRoute>
            } />

            <Route path="/committee-validation/:sentToken/:status" element={<CommitteeValidationPage />} />
            <Route path="/hero-yonetimi" element={
              <ProtectedRoute>
                <HeroManagementPage />
              </ProtectedRoute>
            } />
          </Routes>
        </ProfileProvider>
      </ThemeProvider>
    </SettingsProvider>
    </html>
  );
}
